import axios from 'axios';
export default {
    state: {
    //页面是否显示加载中
    isLoading: false,
    //当前正在加载中的接口个数
    promising: 0,
    openId:localStorage.getItem('accessOpenId')?localStorage.getItem('accessOpenId'):'',
    //获取用户信息
    userInfo:(localStorage.getItem('userInfo')!='undefined'&&localStorage.getItem('userInfo'))?JSON.parse(localStorage.getItem('userInfo')):{},
    token: localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '',
    popNo: sessionStorage.getItem('popNo') ? sessionStorage.getItem('popNo') : false,
    orgTitle: localStorage.getItem('orgTitle') ? localStorage.getItem('orgTitle') : '智能零售商城',
    izReceive: sessionStorage.getItem('izReceive') ? sessionStorage.getItem('izReceive') : false,
    ticket: sessionStorage.getItem('ticket') ? sessionStorage.getItem('ticket') : '',
  },
  getters: {
    //是否显示页面加载中
    isLoading : state => {
      return state.isLoading;
    },
  },
  mutations: {
    //更改请求中接口的个数
    changePromising (state,type) {
      if (type === 'add') {
          state.promising++;
      } else if (type === 'del') {
          state.promising--;
      }
      if (state.promising > 0) {
          state.isLoading = true;
      } else {
          state.isLoading = false;
      }
    },
    //存储token,用户信息
    CHANGE_INFO(state, data) {
      state.openId = data.userInfo.openId;
      localStorage.setItem('accessOpenId', data.userInfo.openId);
      state.token = data.userInfo.token;
      localStorage.setItem('accessToken', data.userInfo.token);
      state.userInfo = data.userInfo;
      localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
    },
    DEL_USER_INFO(state){
      state.token ='';
      localStorage.removeItem("accessToken");
      state.userInfo ={};
      localStorage.removeItem("userInfo");
      state.openId ='';
      localStorage.removeItem("accessOpenId");
      state.orgTitle = '';
      localStorage.removeItem('orgTitle' );
      // state.popNo = false;
      // sessionStorage.removeItem('popNo');
    },
    SET_POP_NO(state, data) {
      state.popNo = data;
      sessionStorage.setItem('popNo', data);
    },
    SET_ORG_TITLE(state, data) { 
      localStorage.setItem('orgTitle', data);
      state.orgTitle = data;
    },
    STE_IZ_RECEIVE(state, data) { 
      sessionStorage.setItem('izReceive', data);
      state.izReceive = data;
    },
    SET_TICKET(state, data) { 
      sessionStorage.setItem('ticket', data);
      state.ticket = data;
    }
    
  },
  actions: {
    submitChangeInfo({commit},data){
      commit("CHANGE_INFO",data);
    },
    submitDelUserInfo({commit}){
      commit("DEL_USER_INFO");
    },
    submitPopNo({ commit }, data) {
      commit("SET_POP_NO",data);
    },
    submitOrgTitle({ commit }, data) {
      commit("SET_ORG_TITLE",data);
    },
    submitIzReceive({ commit }, data) {
      commit("STE_IZ_RECEIVE",data);
    },
    submitTicket({ commit }, data) {
      commit("SET_TICKET",data);
    }
  },
}
